import { jsxs as r, jsx as t } from "react/jsx-runtime";
import { Typography as e } from "../Typography/Typography.js";
import "js-cookie";
import "react";
import { useMediaQuery as h } from "../../hooks/useMediaQuery.js";
import i from "clsx";
import '../../_assets/InfoItem.D-4gbSpP.css';const v = "_item_3tnco_44", f = "_btn_3tnco_50", x = "_icon_3tnco_61", y = "_row_large_3tnco_76", N = "_row_small_3tnco_77", k = "_col_small_3tnco_81", z = "_col_large_3tnco_85", o = {
  item: v,
  btn: f,
  icon: x,
  row_large: y,
  row_small: N,
  col_small: k,
  col_large: z,
  "slide-in-out": "_slide-in-out_3tnco_1",
  "fade-in-out": "_fade-in-out_3tnco_1"
}, P = (_) => {
  const {
    label: m,
    value: l,
    direction: c = "row",
    size: p = "small",
    variant: d = "desktop",
    className: u,
    valueClassName: g,
    asBtn: a = !1,
    onClick: w,
    iconBtn: s
  } = _, b = i(
    o.item,
    o[`${c}_${p}`],
    o[`${c}_${d}`],
    u
  ), n = h("s");
  return /* @__PURE__ */ r("div", { className: b, children: [
    /* @__PURE__ */ t(
      e,
      {
        variant: "portalText",
        size: n ? "1" : "2",
        component: "p",
        color: "grey-1-new",
        noPadding: !0,
        children: m
      }
    ),
    !a && /* @__PURE__ */ t(
      e,
      {
        variant: "portalText",
        size: n ? "1" : "2",
        component: "p",
        weight: "700",
        color: "black-new",
        noPadding: !0,
        children: l
      }
    ),
    a && /* @__PURE__ */ r("button", { type: "button", className: o.btn, onClick: w, children: [
      /* @__PURE__ */ t(
        e,
        {
          variant: "portalText",
          size: n ? "1" : "2",
          component: "p",
          weight: "700",
          color: "black-new",
          className: i(o.value, g),
          children: l
        }
      ),
      s && /* @__PURE__ */ t("span", { className: o.icon, children: s })
    ] })
  ] });
};
export {
  P as InfoItem
};
